import { CommonModule } from '@angular/common';
import { Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SidebarComponent } from './sidebar.component';
import { SidebarService } from '../../services/sidebar.service';

@Component({
  selector: 'app-layout',
  imports: [CommonModule, SidebarComponent],
  template: `
    <app-sidebar></app-sidebar>
    <!-- Main content: shifts to clear the sidebar on large screens
         (full width on mobile, where the sidebar is an overlay). -->
    <div
      class="transition-all duration-300"
      [class.lg:pl-64]="sidebarOpen"
      [class.lg:pl-16]="!sidebarOpen"
    >
      <!-- No top padding: the .ap-nav header is position:sticky (in flow), so it
           already reserves its height. A pt-16 here only makes sense for a
           position:fixed header and just adds a dead gap below the nav. -->
      <ng-content></ng-content>
    </div>
  `,
  styleUrl: './layout.component.scss',
})
export class LayoutComponent {
  sidebarOpen = false;
  private destroyRef = inject(DestroyRef);

  constructor(private sidebarService: SidebarService) {
    this.sidebarService.sidebarOpen$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((open) => (this.sidebarOpen = open));
  }
}
